import { render, staticRenderFns } from "./TMPlacements.man.vue?vue&type=template&id=390ff3bc&scoped=true&lang=html&"
import script from "./TMPlacements.man.vue?vue&type=script&lang=js&"
export * from "./TMPlacements.man.vue?vue&type=script&lang=js&"
import style0 from "./TMPlacements.man.vue?vue&type=style&index=0&id=390ff3bc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ff3bc",
  null
  
)

export default component.exports